import { formatDuration } from '../../utils/format'
import { ServicePrice } from './ServicePrice'
import type { Service } from '../../types/storefront'

export interface ServiceRowProps {
  service: Service
  onOpen: (service: Service) => void
}

/** The services page uses Stitch's list layout rather than the image card:
 *  a menu reads faster than a grid when a customer is comparing prices. */
export function ServiceRow({ service, onOpen }: ServiceRowProps) {
  return (
    <button
      type="button"
      onClick={() => onOpen(service)}
      className="group flex w-full items-start justify-between gap-6 rounded-lg border border-transparent bg-surface-container-lowest p-6 text-left transition-colors hover:border-outline-variant hover:bg-surface-container-low focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
    >
      <div className="min-w-0 flex-1">
        <h3 className="mb-2 font-display text-headline-sm text-on-surface">{service.name}</h3>
        {service.description && (
          <p className="mb-2 line-clamp-2 font-body-md text-body-md text-on-surface-variant">{service.description}</p>
        )}
        <span className="font-label-caps text-label-caps uppercase text-primary">
          {formatDuration(service.duration)}
        </span>
      </div>

      <div className="flex shrink-0 flex-col items-end gap-4 text-right">
        <ServicePrice service={service} />
        <span className="border-b border-primary pb-1 font-label-caps text-label-caps uppercase text-primary transition-all group-hover:border-b-2">
          View details
        </span>
      </div>
    </button>
  )
}
